// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditableModal_modal__1I0Gb"};